var _module = require('../../components/module');
var _ = require('lodash');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$confirmationModal', [
    '$log',
    '$uibModal',

    function $confirmationModal($log, $uibModal) {
        return function openConfirmationModal(options) {
            var defaultOptions = {
                title: '',
                message: '',
                buttons: {
                    cancel: {
                        label: 'Cancel',
                        value: false,
                        visible: false
                    },
                    ok: {
                        label: 'Ok',
                        value: true,
                        visible: true
                    }
                },
                modalOptions: {
                    keyboard: true,
                    backdrop: true,
                    backdropClass: ''
                }
            };
            options = _.merge(defaultOptions, options);

            var modal = $uibModal.open({
                animation: false,
                template: require('./index.html'),
                controller: [
                    '$scope',

                    function confirmationCtrl($scope) {
                        $scope.model = options;
                    }
                ],
                keyboard: options.modalOptions.keyboard,
                backdrop: options.modalOptions.backdrop,
                backdropClass: 'confirmation-modal-backdrop ' + options.modalOptions.backdropClass,
                windowClass: 'confirmation-modal'
            });

            return modal;
        };
    }
]);
